import { defineMessages } from 'react-intl-next';

export const messages: {
	ai_answer_component_report_consent_checkbox_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_answer_component_report_modal_title: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_answer_component_report_summary_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_answer_component_report_details_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_answer_component_report_empty_option_share_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_answer_component_report_relevance_option_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_answer_component_report_inaccurate_option_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_answer_component_report_offensive_option_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_answer_component_report_other_option_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_answer_component_summary_placeholder_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_answer_component_feedback_flag_description: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_answer_component_like_button_tooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_answer_component_dislike_button_tooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	ai_answer_component_report_consent_checkbox_label: {
		id: 'search_ai.ai_answer_component_report_consent_checkbox_label',
		defaultMessage: 'Include my last prompt and response in the feedback.',
		description:
			'Label for the checkbox asking for user consent to include their AI prompt and response in their feedback',
	},
	ai_answer_component_report_modal_title: {
		id: 'search_ai.ai_answer_component_report_modal_title',
		defaultMessage: 'Help us improve {featureTitle}',
		description: 'Label text for the summary section of the report feedback collector',
	},
	ai_answer_component_report_summary_label: {
		id: 'search_ai.ai_answer_component_report_summary_label',
		defaultMessage: 'Was there a problem with the response? Let us know what happened.',
		description: 'Label text for the summary section of the report feedback collector',
	},
	ai_answer_component_report_details_label: {
		id: 'search_ai.ai_answer_component_report_details_label',
		defaultMessage: 'Describe the issue',
		description: 'Label text for the summary text box for the report feedback collector',
	},
	ai_answer_component_report_empty_option_share_label: {
		id: 'search_ai.ai_answer_component_report_empty_option_share_label',
		defaultMessage: 'I want to share...',
		description: 'Label text for the empty feedback type option of the report feedback collector',
	},
	ai_answer_component_report_relevance_option_label: {
		id: 'search_ai.ai_answer_component_report_relevance_option_label',
		defaultMessage: 'This isn’t relevant or isn’t what I expected',
		description:
			'Label text for the relevance feedback type option of the report feedback collector',
	},
	ai_answer_component_report_inaccurate_option_label: {
		id: 'search_ai.ai_answer_component_report_inaccurate_option_label',
		defaultMessage: 'This is inaccurate or misleading',
		description:
			'Label text for the inaccurate feedback type option of the report feedback collector',
	},
	ai_answer_component_report_offensive_option_label: {
		id: 'search_ai.ai_answer_component_report_offensive_option_label',
		defaultMessage: 'This is offensive or harmful',
		description:
			'Label text for the offensive feedback type option of the report feedback collector',
	},
	ai_answer_component_report_other_option_label: {
		id: 'search_ai.ai_answer_component_report_other_option_label',
		defaultMessage: 'Something else',
		description: 'Label text for the other feedback type option of the report feedback collector',
	},
	ai_answer_component_summary_placeholder_label: {
		id: 'search_ai.ai_answer_component_summary_placeholder_label',
		defaultMessage: 'Explain the problem you experienced',
		description: 'Label text for the summary placeholder for the report feedback collector',
	},
	ai_answer_component_feedback_flag_description: {
		id: 'search_ai.ai_answer_component_feedback_flag_descriptionl',
		defaultMessage: 'We appreciate you taking the time to send this feedback',
		description: 'Description text for the feedback flag in the ai answer component',
	},
	ai_answer_component_like_button_tooltip: {
		id: 'search_ai.ai_answer_component_like_button_tooltip',
		defaultMessage: 'Good response',
		description: 'Tooltip text for the ai answer component like button',
	},
	ai_answer_component_dislike_button_tooltip: {
		id: 'search_ai.ai_answer_component_dislike_button_tooltip',
		defaultMessage: 'Bad response',
		description: 'Tooltip text for the ai answer component dislike button',
	},
});
